module.exports = __webpack_public_path__ + "static/img/lineup_cmt_j_lemonade.844eed6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lineup_cmt_j_lemonade.svg
// module id = B21q
// module chunks = 1